import React from "react";
import Button from "../shared/Button/Button";

interface LoginPageBtnProps {
  label: any;
  onClick: () => any;
  type?: "submit" | "reset" | "button";
  loading?: boolean;
}

const LoginPageBtn: React.FC<LoginPageBtnProps> = ({
  label,
  type = "button",
  onClick,
  loading,
}) => {
  return (
    <Button
      onClick={onClick}
      type={type}
      loading={loading}
      className="w-full bg-black text-blue32 md:p-[4px_10px] p-[7px] text-[13px] rounded-md hover:bg-black focus:outline-none focus:text-white font-bold mb-1"
    >
      {label}
    </Button>
  );
};

export default LoginPageBtn;
